import User from "@/store/models/user";
import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";
import Vue from 'vue'


export class Vserver extends Model {

  static entity = 'vservers'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      hostname: this.attr(null),

      type: this.attr(null),
      memory: this.attr(null),
      cores: this.attr(null),
      disk: this.attr(null),
      max_backups: this.attr(null),
      max_scheduled_tasks: this.attr(null),
      backups:this.attr(null),
      addresses_v4:this.attr(null),
      start_at_boot: this.attr(null),
      traffic: this.attr(null),
      password: this.attr(null),
      reseller_accounting: this.attr(null),
      template: this.attr(null),
      vserver_template: this.attr(null),

      created_at: this.attr(null),
      updated_at: this.attr(null),

      username: this.attr(null),
      user: this.belongsTo(User, 'username'),

      status: this.attr(null)
    }
  }
  /*
  static all(){
   //const response =  await axios.get('/domain/nameservers')
    //return response
    const response = [1,2,3]
    return response
  }
   */
  static async deleteVserver(vid){
    const x = axios.delete("/datacenter/vservers/"+vid+"/delete")
  }
  static async newInstallation(vid,os){
    const x = axios.post("/datacenter/vservers/"+vid+"/reinstall",{
        vserver_template:os,
        vserver_id:vid
    })
  }
  static async fetch(id) {
    if (!id) return
    const response = await axios.get('/datacenter/vservers/' + id)
    this.insertOrUpdate({data: response.data.vserver})
  }
  static async fetchStatus(id) {
    if(!Vserver.find(id)) Vserver.fetch(id)
    const res = await axios.get('/datacenter/vservers/' + id + '/status')
      .then(response=>{
        Vserver.update({where:id,data:response.data})
      })
      .catch(
        error=>{
          return error
        }
      )
    //Vue.set(this, 'status', response.data.status)
  }
}

export default Vserver



// WEBPACK FOOTER //
// ./src/store/models/vserver/vserver.js